import { SelectCombo } from 'components/Types/GeneralTypes'
import SelectItem from 'components/Varios/select'
import React from 'react'
import {Row,Col,FormGroup,Label} from "reactstrap"

type PropComboIncluirCertifcado = {
    value:string,
    label:string,
    onChange:(valor:string) => void
}






export default function ComboIncluirOpcionCertificado(props:PropComboIncluirCertifcado) {

    const opcionesSelect: SelectCombo[] = [
        {
            label: "SI",
            value: "true"
        },
        {
            label: "NO",
            value: "false"
        }
    ]


    function OnChangeSelectCertificado (valor:string) {
        props.onChange(valor);
    }

    return (
        <Row form>
            <Col md={12}>
                <FormGroup>
                    <Label for="incluirSelectCertificados"> {props.label}  </Label>
                    <SelectItem
                        options={opcionesSelect}
                        value={props.value}
                        onChange={(e:string) => OnChangeSelectCertificado(e)}
                        placeholder=""
                        name="incluirSelectCertificados"
                        id="incluirSelectCertificados"
                        icon="fa-caret-right" />
                </FormGroup>
            </Col>
        </Row>
    )
}
